module.exports = __webpack_public_path__ + "static/media/Darsena - Ind.Blue_DK Grey.31109458.jpg";